import {Plan} from 'types/plan'
import {hasMultiRowManholes} from "./lid";

export type LimitingReason = 'none' | 'subfloorLidType' | 'beveledCollar' | 'withoutCollar' | 'multiRowManholes'

export const getMaxAllowedManholeCount = (plan: Plan): [number, LimitingReason] => {
    if (!plan || !plan.lid || !plan.lid.type) return [0, 'none'];
    const lidType = plan.lid.type;
    const collar = plan.lid.collar ?? 'without';

    if (lidType === 'subfloor') return [1, 'subfloorLidType'];
    if (collar === 'beveled' && !plan.intermediateCeiling) return [1, 'beveledCollar'];
    if (collar === 'without' && !plan.intermediateCeiling) return [1, 'withoutCollar'];
    if (hasMultiRowManholes(plan)) return [1, "multiRowManholes"];
    return [Infinity, 'none'];
}

export default getMaxAllowedManholeCount
